import React, { useEffect, useState } from 'react';
import {
  Button,
  Collapse,
  Divider,
  Modal,
  notification,
  Pagination,
  Spin,
  Table,
  Tabs,
  Tag,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

//	styles
import '../../assets/css/shop.css';
import '../../assets/css/restaurnt.css';

// compoenents
import Navbar from '../../components/Navbar';
import RestaurantSideNav from '../../components/dashboard/restaurant_side_nav';
import InfoSlider from '../../components/Restaurant/Dashboard/InfoSlider';
import NumberFormat from 'react-number-format';
import { DateTime } from 'luxon';
import {
  _accept_restaurant_order,
  _confirmPickupCode,
  _get_restaurant_order,
  _get_vendor_restaurant,
  _ready_restaurant_order,
  _reject_restaurant_order,
  _update_restaurant_profile,
} from '../../common/axios_services';
import { Link, useNavigate } from 'react-router-dom';
import MobileDashTabs from '../../components/dashboard/MobileDashTabs';
import {
  _fetch_user_wallet_data,
  _get_profile,
} from '../../common/axios_services';
import BecomeRestaurant from '../../components/modals/BecomeRestaurant';
import { Switch } from 'antd';
import moment from 'moment';
import waiting_approval from '../../assets/images/restaurant/waiting_approval.png';
import failed_approval from '../../assets/images/restaurant/failed_approval.mp4';
import { OpenResturantModal } from '../../components/OpenResturant';
import RestaurantTransferModal from '../../components/transactions/RestaurantTransferModal';

const RestaurantDashboard = () => {
  const { TabPane } = Tabs;
  const newAntIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: '#008060' }} spin />
  );
  const navigate = useNavigate();
  // States
  const openTimeFormat = 'HH:mm'; // Use HH:mm format for hours and minutes
  const [spinnerLoading, setSpinnerLoading] = React.useState(false);
  const [today_page, setTodayPage] = React.useState(1);
  const [today_per_page, setTodayPerPage] = React.useState(10);
  const [today_total, setTodayTotal] = React.useState(10);
  const [today_history, setTodayHistory] = React.useState([]);
  const [vendorRestaurant, setVendorRestaurant] = React.useState();
  const [isVendor, setIsVendor] = useState(false);
  const [isRestaurant, setIsRestaurant] = useState(false);
  const [restaurantOpenState, setRestaurantOpenState] = useState(true);
  const [isApproved, setIsApproved] = useState('');
  const [openTime, setOpenTime] = React.useState(
    moment('09:00', openTimeFormat)
  );
  const [closeTime, setCloseTime] = React.useState(
    moment('17:00', openTimeFormat)
  );
  const [orderHist, setOrderHist] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isReadyModal, setIsReadyModal] = useState(false);
  const [isConfirmCode, setIsConfirmCode] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);

  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      message: title,
      description: message,
      placement: 'bottom-right',
    });
  };

  const orderColumns = [
    {
      title: 'S/N',
      dataIndex: 'sn',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Time',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: 'Customer',
      dataIndex: ['user', 'first_name'],
      key: 'user_first_name',
    },
    {
      title: 'Ref Code',
      dataIndex: 'track_id',
      key: 'track_id',
      render: (text) => `#${text}`,
    },
    {
      title: 'Item',
      dataIndex: 'item',
      key: 'item_quantity',
      render: (items) =>
        items.map((item) => item.quantity).reduce((a, b) => a + b, 0), // Sum of item quantities
    },
    {
      title: 'Sales',
      dataIndex: 'settleAmount',
      key: 'sales',
      render: (text) => (
        <NumberFormat
          value={Number(text)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'₦'}
        />
      ),
    },
    {
      title: 'Del. Type',
      dataIndex: 'delivery_type',
      key: 'delivery_type',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const displayStatus =
          status === 'confirmed'
            ? 'Pending'
            : status.charAt(0).toUpperCase() + status.slice(1);

        const tagColor =
          status === 'confirmed'
            ? 'orange'
            : status === 'canceled' || status === 'rejected'
            ? 'red'
            : 'green';

        return <Tag color={tagColor}>{displayStatus}</Tag>;
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Button type="link" onClick={() => handleViewClick(record)}>
          View
        </Button>
      ),
    },
  ];

  // Functions
  const change_today_pagination = (selected_page, pageSize) => {
    setTodayPage(selected_page);
    setTodayPerPage(pageSize);
  };

  useEffect(() => {
    if (vendorRestaurant?.is_open !== undefined) {
      setRestaurantOpenState(vendorRestaurant.is_open); // Update state when vendorRestaurant changes
    }
  }, [vendorRestaurant]);

  // TABLE HISTORY

  const getRestaurantOrderHist = async () => {
    try {
      setSpinnerLoading(true);
      const get_hist = await _get_restaurant_order();
      setOrderHist(get_hist.data.data);
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  // Filter functions
  const filterTodayOrders = (orders) => {
    const today = moment().startOf('day');
    return orders.filter((order) =>
      moment(order.created_at).isSame(today, 'day')
    );
  };

  const filterPreviousOrders = (orders) => {
    const today = moment().startOf('day');
    return orders.filter((order) =>
      moment(order.created_at).isBefore(today, 'day')
    );
  };

  // Separate orders
  const todaysOrders = orderHist?.data ? filterTodayOrders(orderHist.data) : [];
  const previousOrders = orderHist?.data
    ? filterPreviousOrders(orderHist.data)
    : [];

  // Preprocess previousOrders to modify deliveryStatus and Action
  const processedPreviousOrders = previousOrders.map((order) => ({
    ...order,
    status: 'delivered', // Set deliveryStatus to "delivered"
    action: null, // Set action to null or blank
  }));

  // ACTION VIEW
  const handleViewClick = (record) => {
    setSelectedOrder(record);
    setIsModalVisible(true);
  };

  const handleAcceptOrder = async () => {
    if (!selectedOrder) return;

    try {
      setIsModalVisible(false);
      setSpinnerLoading(true);
      const response = await _accept_restaurant_order(selectedOrder.id);
      openNotificationWithIcon('success', 'Order accepted successfully!');
      getRestaurantOrderHist();
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  const handleRejectOrder = async () => {
    if (!selectedOrder) return;

    try {
      setIsModalVisible(false);
      setSpinnerLoading(true);
      const response = await _reject_restaurant_order(selectedOrder.id);
      openNotificationWithIcon('success', 'Order rejected successfully!');
      setIsReadyModal(false);
      getRestaurantOrderHist();
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  const handleReadyOrder = async () => {
    if (!selectedOrder) return;

    try {
      setIsReadyModal(false);
      setSpinnerLoading(true);
      const response = await _ready_restaurant_order(selectedOrder.id);
      openNotificationWithIcon('success', 'Order is ready!');
      getRestaurantOrderHist();
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  const handleConfirmPickupCode = async () => {
    if (!selectedOrder || !isConfirmCode) {
      openNotificationWithIcon('error', 'Please enter a valid code.');
      return;
    }

    try {
      setSpinnerLoading(true);
      const response = await _confirmPickupCode(
        selectedOrder.id,
        isConfirmCode
      );

      if (response.data.status === 'success') {
        setIsModalVisible(false);
      }
      setIsConfirmCode('');
      openNotificationWithIcon('success', 'Pickup Code is confirmed!');
      getRestaurantOrderHist();
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  const fetchRestaurant = async () => {
    try {
      setSpinnerLoading(true);
      let response = await _get_vendor_restaurant();
      const dataResult = response?.data?.data || {};
      setVendorRestaurant(dataResult);
      setIsApproved(dataResult.status);

      // if time > open time and < close time THEN setRestaurantOpenState is true
      // If time is strictly >= close time AND time is < open_time setRestaurantOpenState is false
      setOpenTime(dataResult.open_time);
      setCloseTime(dataResult.close_time);
      const currentTime = moment();

      if (currentTime.isBetween(openTime, closeTime)) {
        setRestaurantOpenState(true);
      } else if (
        currentTime.isBefore(openTime) ||
        currentTime.isAfter(closeTime)
      ) {
        setRestaurantOpenState(false);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  const getUserProfile = async () => {
    try {
      let result = await _get_profile();
      const vendorStatus = result?.data?.data.is_so;
      setIsVendor(vendorStatus); // Update state
      setIsRestaurant(result?.data?.data.is_restaurant);

      if (!vendorStatus) {
        navigate('/profile/loyalty');
      } // hidden to non-vendors
    } catch {}
  };

  const handleSwitch = async (checked) => {
    if (!vendorRestaurant) return;

    const { id, cooking_area_image, ...res_data } = vendorRestaurant; // Extract and exclude cooking_area_image if null
    const data = {
      ...res_data,
      cooking_area_image: Array.isArray(cooking_area_image)
        ? cooking_area_image
        : [], // Ensure it is an array
      is_open: checked, // Update only the is_open property based on toggle state
    };

    try {
      setSpinnerLoading(true);
      const updateRestaurantProfile = await _update_restaurant_profile(
        id,
        data
      );
      openNotificationWithIcon(
        'success',
        updateRestaurantProfile?.data?.title,
        updateRestaurantProfile?.data?.message
      );
      setRestaurantOpenState(checked); // Update UI state based on the toggle
    } catch (err) {
      if (err.response) {
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  useEffect(() => {
    getUserProfile();
    fetchRestaurant();
  }, []);

  useEffect(() => {
    getRestaurantOrderHist();
  }, []);

  return (
    <>
      <div className="userprofile">
        {[false].includes(restaurantOpenState) && (
          <OpenResturantModal onOpen={handleSwitch} />
        )}
        <Spin spinning={spinnerLoading} indicator={newAntIcon}>
          <div className="profile-content">
            <Navbar />
            <div className="gray_bg_profile">
              <div className="profile_to_left">
                <div className="">
                  <div className="profile_nav">
                    <RestaurantSideNav />
                  </div>
                </div>
              </div>
              <div className="profile_to_right">
                <div className="contain">
                  <div className="main_container">
                    <MobileDashTabs />
                    {
                      // IF VENDOR BUT NOT RESTAURANT
                      isVendor && !isRestaurant ? (
                        <>
                          <BecomeRestaurant />
                        </>
                      ) : // IF RESTAURANT BUT NOT APPROVED
                      isApproved === 'pending' ? (
                        <>
                          <div className="flex flex-col pt-4 justify-center items-center ">
                            <img
                              src={waiting_approval}
                              className="md:w-1/3 md:h-1/3  w-full h-full   "
                              alt=""
                            />
                            <p>Your restaurant is waiting for approval...</p>
                          </div>
                        </>
                      ) : //  IF RESTAURANT APPROVAL FAILED
                      isApproved === 'rejected' ? (
                        <>
                          <div className="flex flex-col justify-center items-center">
                            <video
                              src={failed_approval}
                              autoPlay
                              loop
                              muted
                              playsInline
                              className="w-1/3 h-1/3 my-5 rounded-lg shadow-md"
                            />
                            <p>
                              Unfortunately your restaurant approval was
                              declined
                            </p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="main_container_title_div">
                            <h5>Dashboard</h5>
                            <Divider style={{ margin: '0px 0 5px' }} />
                          </div>
                          {/* Restaurant Dashboard Slider  */}
                          <InfoSlider />

                          <div className="flex justify-between mb-10 px-4">
                            {/* Resturant Transfer Modal */}
                            <div className="my-auto">
                              <RestaurantTransferModal />
                            </div>
                            {/* Restaurant Toggle Time */}
                            <div className="h-full">
                              <div className="flex align-center justify-end w-full space-x-5 py-4">
                                <p
                                  className={` ${
                                    !restaurantOpenState
                                      ? 'text-[red]'
                                      : 'text-black'
                                  }  text-[14px]    `}
                                >
                                  {restaurantOpenState
                                    ? 'Restaurant is Opened'
                                    : 'Restaurant is Closed'}
                                </p>
                                <Switch
                                  className={`${
                                    restaurantOpenState
                                      ? 'bg-[#258635]'
                                      : 'bg-[grey]'
                                  }`}
                                  checked={restaurantOpenState}
                                  onChange={handleSwitch}
                                />
                              </div>
                            </div>
                          </div>

                          {/* Restaurant table */}
                          <Tabs type="card">
                            <TabPane tab="Today's history" key="1">
                              {!today_history ? (
                                <div>
                                  <Spin indicator={newAntIcon} />
                                </div>
                              ) : (
                                <>
                                  <div>
                                    <div className="desktop show-all">
                                      <Table
                                        scroll={{ x: true }}
                                        pagination={false}
                                        bordered
                                        columns={orderColumns}
                                        dataSource={todaysOrders}
                                      />
                                      <div style={{ marginTop: '2%' }}></div>
                                      <Pagination
                                        showSizeChanger
                                        current={today_page}
                                        total={today_total}
                                        showTotal={(total, range) =>
                                          `${range[0]} - ${range[1]} of ${total} transaction`
                                        }
                                        defaultPageSize={today_per_page}
                                        onChange={change_today_pagination}
                                      />
                                    </div>
                                    <div className="mobile topup-data">
                                      <Collapse defaultActiveKey={[0]}>
                                        {todaysOrders.map((order, index) => (
                                          <Collapse.Panel
                                            showArrow={false}
                                            key={index}
                                            header={
                                              <p style={{ display: 'inline' }}>
                                                {/*<span>*/}
                                                {/*	<span*/}
                                                {/*		className="currency">NGN</span>*/}
                                                {/*	<NumberFormat*/}
                                                {/*		thousandSeparator={true}*/}
                                                {/*		displayType={'text'}*/}
                                                {/*		value={Math.round(Number(order.settleAmount) * 1)}*/}
                                                {/*	/>*/}
                                                {/*</span>*/}
                                                Ordered on{' '}
                                                {new Date(
                                                  order.created_at
                                                ).toLocaleString()}
                                              </p>
                                            }
                                          >
                                            <div>
                                              <ul className="mobile-list-flex">
                                                <li>
                                                  <span>Date:</span>
                                                  <span>
                                                    {order.created_at}
                                                  </span>
                                                </li>
                                                <li>
                                                  <span>Ref Code:</span>
                                                  <span>#{order.track_id}</span>
                                                </li>
                                                <li>
                                                  <span>Item:</span>
                                                  <span>
                                                    {Array.isArray(order.item)
                                                      ? order.item
                                                          .map(
                                                            (item) =>
                                                              item.quantity || 0
                                                          )
                                                          .reduce(
                                                            (a, b) => a + b,
                                                            0
                                                          )
                                                      : 0}
                                                  </span>
                                                </li>
                                                <li>
                                                  <span>Status:</span>
                                                  <span>
                                                    {
                                                      <Tag
                                                        color={
                                                          order.status ===
                                                            'accepted' ||
                                                          order.status ===
                                                            'ready'
                                                            ? 'green'
                                                            : order.status ===
                                                              'confirmed'
                                                            ? 'orange'
                                                            : order.status ===
                                                              'canceled'
                                                            ? 'red'
                                                            : 'orange'
                                                        }
                                                      >
                                                        {order.status ===
                                                        'confirmed'
                                                          ? 'Pending'
                                                          : order.status
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            order.status.slice(
                                                              1
                                                            )}
                                                      </Tag>
                                                    }
                                                  </span>
                                                </li>
                                                <div className="mt-3">
                                                  <Button
                                                    type="link"
                                                    onClick={() =>
                                                      handleViewClick(order)
                                                    }
                                                  >
                                                    View
                                                  </Button>
                                                  {/*<Link*/}
                                                  {/*    to={`/review-order/${order.transaction_ref}`}>*/}
                                                  {/*    <Button type="link">View*/}
                                                  {/*        Order</Button>*/}
                                                  {/*</Link>*/}
                                                </div>
                                                {/* <li><span>Action:</span><span><Button onClick={() => {setActiveHistorySelection(trans); setActiveHistoryDisplayModal(true);}}>View</Button></span></li> */}
                                              </ul>
                                            </div>
                                          </Collapse.Panel>
                                        ))}
                                      </Collapse>
                                      <div style={{ marginTop: '1%' }}>
                                        <Pagination
                                          showSizeChanger
                                          current={today_page}
                                          total={today_total}
                                          showTotal={(total, range) =>
                                            `${range[0]} - ${range[1]} of ${total} transaction`
                                          }
                                          defaultPageSize={today_per_page}
                                          onChange={change_today_pagination}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </TabPane>
                            <TabPane tab="Previous Orders" key="2">
                              {!today_history ? (
                                <div>
                                  <Spin indicator={newAntIcon} />
                                </div>
                              ) : (
                                <>
                                  <div>
                                    <div className="desktop show-all">
                                      <Table
                                        scroll={{ x: true }}
                                        pagination={false}
                                        bordered
                                        columns={orderColumns}
                                        dataSource={processedPreviousOrders}
                                      />
                                      <div style={{ marginTop: '1%' }}></div>
                                      <Pagination
                                        showSizeChanger
                                        current={today_page}
                                        total={today_total}
                                        showTotal={(total, range) =>
                                          `${range[0]} - ${range[1]} of ${total} transaction`
                                        }
                                        defaultPageSize={today_per_page}
                                        onChange={change_today_pagination}
                                      />
                                    </div>
                                    <div className="mobile topup-data ">
                                      <Collapse defaultActiveKey={[0]}>
                                        {previousOrders.map((order, index) => (
                                          <Collapse.Panel
                                            showArrow={false}
                                            key={index}
                                            header={
                                              <p style={{ display: 'inline' }}>
                                                <span>
                                                  {/*<span*/}
                                                  {/*	className="currency">NGN </span>*/}
                                                  {/*<NumberFormat*/}
                                                  {/*	thousandSeparator={true}*/}
                                                  {/*	displayType={'text'}*/}
                                                  {/*	value={Math.round(Number(order.settleAmount) * 1)  }*/}
                                                  {/*/>*/}
                                                  Ordered on{' '}
                                                  {new Date(
                                                    order.created_at
                                                  ).toLocaleString()}
                                                </span>
                                              </p>
                                            }
                                          >
                                            <div>
                                              <ul className="mobile-list-flex">
                                                <li>
                                                  <span>Date:</span>
                                                  <span>
                                                    {order.created_at}
                                                  </span>
                                                </li>
                                                <li>
                                                  <span>Ref Code:</span>
                                                  <span>#{order.track_id}</span>
                                                </li>
                                                <li>
                                                  <span>Item:</span>
                                                  <span>
                                                    {Array.isArray(order.item)
                                                      ? order.item
                                                          .map(
                                                            (item) =>
                                                              item.quantity || 0
                                                          )
                                                          .reduce(
                                                            (a, b) => a + b,
                                                            0
                                                          )
                                                      : 0}
                                                  </span>
                                                </li>
                                                <li>
                                                  <span>Status:</span>
                                                  <span>
                                                    {
                                                      <Tag
                                                        color={
                                                          order.status ===
                                                            'accepted' ||
                                                          order.status ===
                                                            'ready'
                                                            ? 'green'
                                                            : order.status ===
                                                              'confirmed'
                                                            ? 'orange'
                                                            : order.status ===
                                                              'canceled'
                                                            ? 'red'
                                                            : 'orange'
                                                        }
                                                      >
                                                        {order.status ===
                                                        'confirmed'
                                                          ? 'Pending'
                                                          : order.status
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            order.status.slice(
                                                              1
                                                            )}
                                                      </Tag>
                                                    }
                                                  </span>
                                                </li>
                                                <div className="mt-3">
                                                  <Button
                                                    type="link"
                                                    onClick={() =>
                                                      handleViewClick(order)
                                                    }
                                                  >
                                                    View
                                                  </Button>
                                                  {/*<Link*/}
                                                  {/*    to={`/review-order/${order.transaction_ref}`}>*/}
                                                  {/*    <Button type="link">View*/}
                                                  {/*        Order</Button>*/}
                                                  {/*</Link>*/}
                                                </div>
                                                {/* <li><span>Action:</span><span><Button onClick={() => {setActiveHistorySelection(trans); setActiveHistoryDisplayModal(true);}}>View</Button></span></li> */}
                                              </ul>
                                            </div>
                                          </Collapse.Panel>
                                        ))}
                                      </Collapse>
                                      <div style={{ marginTop: '1%' }}>
                                        <Pagination
                                          showSizeChanger
                                          current={today_page}
                                          total={today_total}
                                          showTotal={(total, range) =>
                                            `${range[0]} - ${range[1]} of ${total} transaction`
                                          }
                                          defaultPageSize={today_per_page}
                                          onChange={change_today_pagination}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </TabPane>
                          </Tabs>
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Modal for Order Details */}
          <Modal
            title="Order Details"
            open={isModalVisible}
            onCancel={() => {
              setIsModalVisible(false);
              setIsConfirmCode('');
            }}
            footer={null}
            centered={true}
            destroyOnClose={true}
            // width={'720px'}
          >
            {selectedOrder && (
              <div>
                <p>
                  <strong>Date:</strong>{' '}
                  {new Date(selectedOrder.created_at).toLocaleString()}
                </p>
                <p>
                  <strong>Ref Code:</strong> #{selectedOrder.track_id}
                </p>
                <p>
                  <strong>Customer Name: </strong>
                  {`${selectedOrder.user.first_name} ${selectedOrder.user.last_name}`}
                </p>
                <p>
                  <strong>Customer Phone: </strong>
                  {`${selectedOrder.user.phone_code} ${selectedOrder.user.phone_number}`}
                </p>
                <p>
                  <strong>Address:</strong>{' '}
                  {selectedOrder.delivery_address_id || 'N/A'}
                </p>

                <p
                  className={`${
                    selectedOrder.status === 'rejected' ? 'text-[red]' : ''
                  }`}
                >
                  <strong>Order Status:</strong> {selectedOrder.status}
                </p>

                <p>
                  <strong>Items Bought:</strong>
                  <ul>
                    {selectedOrder.item.map((item, index) => (
                      <li key={index}>
                        {item.product_type === 'extra' ? (
                          <p>
                            Extra: {item.quantity} of {item.extra.name}
                          </p>
                        ) : item.product_type === 'menu' ? (
                          <p>
                            {' '}
                            Menu: {item.quantity} of {item.menu.name}
                          </p>
                        ) : (
                          ''
                        )}
                      </li>
                    ))}
                  </ul>
                </p>
                <p>
                  <strong>Restaurant Value: </strong>
                  <NumberFormat
                    value={selectedOrder.settleAmount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'₦'}
                  />
                </p>

                {selectedOrder.status === 'confirmed' && (
                  <div className={'flex my-10 justify-end '}>
                    <Button
                      type="primary"
                      onClick={handleAcceptOrder}
                      style={{ marginRight: 8 }}
                    >
                      Accept Order
                    </Button>
                    <Button danger onClick={handleRejectOrder}>
                      Reject Order
                    </Button>
                  </div>
                )}

                {selectedOrder.status === 'accepted' && (
                  <div className={'flex my-10 justify-end '}>
                    <Button
                      className={`bg-[green] py-3 flex justify-center items-center px-3 text-white rounded-lg shadow  hover:bg-green-500 `}
                      onClick={() => {
                        setIsReadyModal(true);
                        setIsModalVisible(false);
                      }}
                      style={{ marginRight: 8 }}
                    >
                      Ready for Pickup
                    </Button>
                  </div>
                )}
                {selectedOrder.status === 'ready' && (
                  <div className={'flex my-10 gap-5 justify-end items-center'}>
                    <p>Enter Buyer's Code: </p>
                    <input
                      className="border py-2 px-8 border-green-600 outline-green-800"
                      placeholder="Enter Buyer's code"
                      value={isConfirmCode}
                      onChange={(e) => setIsConfirmCode(e.target.value)} // Update state on input change
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleConfirmPickupCode(); // Trigger function on Enter key press
                      }}
                    />
                    <button
                      className="bg-green-600 text-white px-5 py-2 rounded-md"
                      onClick={handleConfirmPickupCode} // Trigger function on button click
                    >
                      Confirm
                    </button>
                  </div>
                )}
              </div>
            )}
          </Modal>

          {/* Modal for Ready Order */}
          <Modal
            title="Order Details"
            open={isReadyModal}
            onCancel={() => setIsReadyModal(false)}
            footer={null}
            centered={true}
          >
            <div>
              <p>
                WE ADVISE THAT YOU CHECK THE FOLLOWING BEFORE YOU CLICKED READY
              </p>
              <ol className={'my-5 px-4 list-decimal '}>
                <li>YOU HAVE SEALED THE FOOD PACK</li>
                <li>YOU ATTACHED THE PICK-UP CODE ON THE BAG</li>
                <li>TIE THE PACKING BAG TO SECURE THE ORDER</li>
              </ol>

              <div className={'flex my-10 justify-end '}>
                <Button
                  className={`bg-[green] py-3 flex justify-center items-center px-3 text-white rounded-lg shadow  hover:bg-green-500 `}
                  onClick={handleReadyOrder}
                  style={{ marginRight: 8 }}
                >
                  Ready
                </Button>
              </div>
            </div>
          </Modal>
        </Spin>
      </div>
    </>
  );
};

export default RestaurantDashboard;
